export default "__VITE_ASSET__BwqhIuvX__"